import { handleActions } from 'redux-actions';
import type {
  BoostInitializationStoreSlice,
  NetworkRequestStatus,
} from '../types';
import {
  initialize,
  initializeSuccess,
  initializeError,
  deinitialize,
  boost,
  boostSuccess,
  boostError,
} from '../actions';
import { reduxKey } from '../constants';

const initialState: BoostInitializationStoreSlice = {
  requestStatus: 'idle' as NetworkRequestStatus,
  requestError: undefined,
  isInitialized: false,
  deviationId: undefined,
  tags: [],
  recommendedTags: [],
  // Boost submission state
  boostStatus: 'idle' as NetworkRequestStatus,
  boostError: undefined,
  isSubmitting: false,
};

const actionHandlers = handleActions<BoostInitializationStoreSlice, any>(
  {
    [`${initialize}`]: (state, action: ReturnType<typeof initialize>) => ({
      ...state,
      requestStatus: 'fetching' as NetworkRequestStatus,
      requestError: undefined,
      deviationId: action.payload.deviationId,
    }),
    [`${initializeSuccess}`]: (
      state,
      action: ReturnType<typeof initializeSuccess>
    ) => ({
      ...state,
      requestStatus: 'success' as NetworkRequestStatus,
      requestError: undefined,
      isInitialized: true,
      isSubmitting: false,
      deviationId: action.payload.deviationId,
      tags: action.payload.tags,
      recommendedTags: action.payload.recommendedTags,
    }),
    [`${initializeError}`]: (
      state,
      action: ReturnType<typeof initializeError>
    ) => ({
      ...state,
      requestStatus: 'error' as NetworkRequestStatus,
      requestError: action.payload.errorMessage,
      isSubmitting: false,
    }),

    [`${deinitialize}`]: (state, action: ReturnType<typeof deinitialize>) => ({
      ...state,
      requestStatus: 'idle' as NetworkRequestStatus,
      requestError: undefined,
      isInitialized: false,
      isSubmitting: false,
      deviationId: undefined,
      tags: [],
      recommendedTags: [],
    }),

    [`${boost}`]: (state, action: ReturnType<typeof boost>) => ({
      ...state,
      boostStatus: 'fetching' as NetworkRequestStatus,
      boostError: undefined,
      isSubmitting: true,
    }),

    [`${boostSuccess}`]: (state, action: ReturnType<typeof boostSuccess>) => ({
      ...state,
      boostStatus: 'success' as NetworkRequestStatus,
      boostError: undefined,
      isSubmitting: false,
    }),

    [`${boostError}`]: (state, action: ReturnType<typeof boostError>) => ({
      ...state,
      boostStatus: 'error' as NetworkRequestStatus,
      boostError: action.payload.errorMessage,
      isSubmitting: false,
    }),
  },
  {
    ...initialState,
  }
);

const reducers = {
  [reduxKey as string]: actionHandlers,
};

export default reducers;
